import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%; 
`;

export const Title = styled.div`
    text-align: center;
    font-size: 64px;
    font-weight: 700;
    line-height: 76px; 
    margin-top: 52px;
    margin-bottom: 30px;
    letter-spacing: -1.28px;
`

export const Desc = styled.div`
    font-size: 30px;
    font-weight: 600;
    line-height: 33.3px;
    margin-bottom: 92px;
`

export const ListContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    border-top: 1px solid black;
    border-left: 1px solid black;
    box-sizing: border-box;

    a {
        text-decoration: none;
        color: black;
    }
        width: 100%;
`;

export const ItemContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 400px;
    height: 253px;
    border: 1px solid black;
    font-size: 27px;
    font-weight: 500;
    text-align: center;
    width: 100%;
    line-height: 37px; 
    letter-spacing: -0.54px;
    box-sizing: border-box;

    &:nth-child(3n+1) { 
        border-left: none;
        border-top: none;
    }

    &:active, &:focus {
        background-color: #F1F1F1; 
    }
`